module.exports = __webpack_public_path__ + "bootleggers_coffee_coffeshop_branded_cover_design02.jpg?aff5bfbcf91809cc570831d931485850";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/bootleggers/bootleggers_coffee_coffeshop_branded_cover_design02.jpg
// module id = 32
// module chunks = 0